// main collection product grid //
  $(document).ready(function(){
    $(document).on('click', '.mobile-facets__open', function(){
      $(document).find('.dev_filter_swtich').first().trigger('click');
    });
    $(document).on('click','.dev_filter_swtich', function(){
      $('.dev_filter_swtich').css({"background-color":"transparent","color" : "black"});
      $(this).parent('.dev_details').attr('open', 'true');
      $(this).css({"background-color":"white","color" : "black"});
      $(document).find('.dev_details').removeClass('menu-opening');
      $(document).find('.dev_details').removeAttr('open');
      $(this).parent('.dev_details').addClass('menu-opening');
    });



    $(document).on('click', '.dev_filters_close', function(){
      $(document).find('aside').find('menu-drawer').find('details').first().removeClass('menu-opening');
      setTimeout(function(){
        $(document).find('aside').find('menu-drawer').find('details').first().removeAttr('open');
      },300);
    });


   $(document).on('click', '.dev_icon_filter', function(){
    //$('body').css('overflow', 'hidden');
    $(document).find('.bottom-nav-bar-parent').hide();
    $(document).find('.header-wrapper').hide();
    $(document).find('.mobile-collection-tab-slk').hide();

     
    // Check if we're between 0 and 140px from the top of the page
    // var scrollPosition = $(window).scrollTop();
    // if (scrollPosition >= 0 && scrollPosition <= 140) {
    //     setTimeout(function() {
    //         $(document).find('.header-wrapper').hide();
    //     }, 0);
    // }
  });
    
  $(document).on('click', '.dev_sort_btn', function(){
    $('body').css('overflow', 'hidden');
    $(document).find('.bottom-nav-bar-parent').hide();
    $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 0});
    // var scrollPosition = $(window).scrollTop();
    // if (scrollPosition >= 0 && scrollPosition <= 140) {
    //     setTimeout(function() {
    //         $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 0});
    //     }, 0);
    // }
  });



    $(document).on('click', '.dev_filters_close', function(){
      $('body').css('overflow', 'unset');
      $(document).find('.bottom-nav-bar-parent').show();
      $(document).find('.mobile-collection-tab-slk').show();
      // $(document).find('.header-wrapper').css({"opacity":"1"});
      $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 200});
      $(document).find('.header-wrapper').show();
    });

    $(document).on('click', '.mobile-facets__close', function(){
      $('body').css('overflow', 'unset');
      $(document).find('.bottom-nav-bar-parent').show();
      $(document).find('.mobile-collection-tab-slk').show();
      // $(document).find('.header-wrapper').css({"opacity":"1"});
      $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 200});
      $(document).find('.header-wrapper').show();
    });

    $(document).on('click', '.disclosure-has-popup[open] > summary', function() {
      $('body').css('overflow', 'unset');
      $(document).find('.bottom-nav-bar-parent').show();
      $(document).find('.mobile-collection-tab-slk').show();
      // $(document).find('.header-wrapper').css({"opacity":"1"});
      $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 200});
      $(document).find('.header-wrapper').show();
    });

    $(document).on('click', '.apply-all-btn', function() {
      $('body').css('overflow', 'unset');
      $(document).find('.bottom-nav-bar-parent').show();
      $(document).find('.mobile-collection-tab-slk').show();
      // $(document).find('.header-wrapper').css({"opacity":"1"});
      $(document).find('.section-header.shopify-section-group-header-group').css({'z-index': 200});
      $(document).find('.header-wrapper').show();
    });

    
    var scroller_oo;

      if ($(window).width() <= 767) { 
          scroller_oo = 0;
      } else {
          scroller_oo = $('.mobile-collection-tab-slk').offset().top + 60;
      }

    // document.body.scrollTop = document.documentElement.scrollTop = 0;

    $(document).on('click', '#FacetsWrapperMobile .mobile-facets__label', function() {
        setTimeout(function() {
        window.scroll({
            top: scroller_oo,
            behavior: "smooth",
        });
      }, 2500);
    });
    $(document).on('click', 'li.list-menu__item.facets__item', function() {
        setTimeout(function() {
        window.scroll({
            top: scroller_oo,
            behavior: "smooth",
        });
      }, 2500);
    });
    
    
    $(document).on('click', '#SortBy-mobile', function() {
        setTimeout(function() {
        window.scroll({
            top: scroller_oo,
            behavior: "smooth",
        });
      }, 2500);
    });
    $(document).on('change', 'select#SortBy', function() {
        setTimeout(function() {
        window.scroll({
            top: scroller_oo,
            behavior: "smooth",
        });
      }, 2500);
    });
   

    

    var isDraggingVariant = false;
    var startXVariant, scrollLeftVariant;

    $('.parent-variant-display').on('mousedown', function(e) {
        isDraggingVariant = true;
        startXVariant = e.pageX - $(this).offset().left;
        scrollLeftVariant = $(this).scrollLeft();
        $(this).css('cursor', 'grabbing');
      e.preventDefault(); // prevent text selection
    });

    $(document).on('mouseup', function() {
        isDraggingVariant = false;
        $('.parent-variant-display').css('cursor', 'grab');
    });

    $('.parent-variant-display').on('mousemove', function(e) {
        if (!isDraggingVariant) return;
        var x = e.pageX - $(this).offset().left;
        var walk = (x - startXVariant) * 1; // Adjust scroll speed
        $(this).scrollLeft(scrollLeftVariant - walk);
    });
  });

// quick short //

$(document).on('click', '.dev_bestselling-origin', function (e) {
    $('.mobile-facets__clear-wrapper').trigger('click');

    var sortName = $(this).data('sortname');
    var triggerElement = $('.dev_trriger_' + sortName);
    
    $('.cstm_shop_btn_short').removeClass(function(index, className) {
        return (className.match(/\bcstm__\S+/g) || []).join(' '); 
    });
    
    setTimeout(function () {
        if (triggerElement.hasClass('active')) {
            // If it's already active, remove the filter
            triggerElement.removeClass('active');
            triggerElement.trigger('click');
        } else {
            // If it's not active, apply the filter
            triggerElement.trigger('click');
        }
        setTimeout(function() {
            triggerElement.addClass('active');
        }, 300);
    }, 300); 
    e.stopImmediatePropagation();
    $('.all_short_add .active-facets__button-wrapper .active-facets__button-remove').removeAttr('style');

    setTimeout(() => {
        $('.cstm_shop_btn_short').addClass('cstm__' + sortName);
    }, 1000);
});

//main collection banner //
$(document).ready(function() {
    let isLoading = false; // Flag to prevent duplicate API calls

    $(document).on('click', '.dev_type_filter', function() {
        if (isLoading) return; // Prevent duplicate calls
        isLoading = true; // Set flag to prevent further calls

        // Set the localStorage item
        localStorage.setItem('pt_filter', $(this).data('value'));
if ($(this).data('value') === "all") {
    console.log("Static all", `dev_${$(this).data('value')}`);

    // Append class to body
    $("body").addClass("dev_all_filter_selected");
  let targetDiv = document.querySelector(".cstm_shop_btn_short");
    
    if (targetDiv) {
        let classList = targetDiv.classList;
        let classes = Array.from(classList);
        let index = classes.indexOf("cstm_shop_btn_short");
        
        if (index !== -1 && classes[index + 1]) {
            let classToRemove = classes[index + 1]; // Next class ko get karna
            targetDiv.classList.remove(classToRemove); // Class remove karna
        }
    }

} else {
    console.log("Static non all", `dev_${$(this).data('value')}`);
    $('.mobile-facets__clear-wrapper').trigger('click');
    // Remove class from body
    $("body").removeClass("dev_all_filter_selected");
}



        // Trigger the click event on the related element
        $(document).find('.dev_' + $(this).data('value')).trigger('click');

        // Change the style of all sibling buttons back to the default and re-enable them
        $(this).siblings().find('.collection-button').css({"background-color":"#FFF","color": "black", "border-color": "#BFBFBF"})
               .attr('disabled', false);

        // Change the style of the current button and disable it
        $(this).find('.collection-button').css({"background-color":"#FF40B1","color": "white", "border-color": "#FF40B1"})
               .attr('disabled', true);

        /* epsilon API code */
        loadScript(`https://dtm.dotandkey.com/profile/visit/js/1_0?dtm_cid=83609&dtm_cmagic=6fcb57&dtm_fid=6986&dtm_promo_id=2&dtm_email_hash=null&dtm_clear_tag=all&dtmc_department=${$(this).data('value')}&dtmc_loc=https%3A%2F%2Fwww.dotandkey.com%2F&cachebuster=${new Date().getTime()}`, function() {
            isLoading = false; // Reset flag after script has loaded
        });
    });

    $(document).on('click', '.active-facets__button-remove', function() {
        // Re-enable all buttons and reset their styles
        $(document).find('.collection-button').css({"background-color":"#FFF","color": "black", "border-color": "#BFBFBF"})
               .attr('disabled', false);
    });

    $(document).on('click', '.active-facets__button-remove', function() {
        // Trigger click event on the first dev_type_filter button
        $(document).find('.dev_type_filter').first().trigger('click');
      
    });

    /* epsilon API start */
    function loadScript(url, callback) {
        const script = document.createElement('script');
        script.src = url;
        document.body.appendChild(script);
        if (callback) {
            script.onload = callback; // Call the callback when script is loaded
        }
    }
  /* epsilon API end */

    document.addEventListener('click', function(event) {
        // check if the clicked element has the class 'dev-false'
        if (event.target.classList.contains('dev-false')) {
            // Find the closest parent with the class 'dev_clear_filter'
            const parentContainer = event.target.closest('.dev_clear_filter');
            if (parentContainer) {
                const spanElement = parentContainer.querySelector('.dev_type_filter facet-remove a span');
                if (spanElement) {
                    spanElement.click();
                }
            }
        }
    });

    var isDragging = false;
    var startX, scrollLeft;

    $('.mobile-collection-tab-slk').on('mousedown', function(e) {
        isDragging = true;
        startX = e.pageX - $(this).offset().left;
        scrollLeft = $(this).scrollLeft();
        $(this).css('cursor', 'grabbing');
        e.preventDefault(); // prevent text selection
    });

    $(document).on('mouseup', function() {
        isDragging = false;
        $('.mobile-collection-tab-slk').css('cursor', 'grab');
    });

    $('.mobile-collection-tab-slk').on('mousemove', function(e) {
        if (!isDragging) return;
        var x = e.pageX - $(this).offset().left;
        var walk = (x - startX) * 1; // Adjust scroll speed
        $(this).scrollLeft(scrollLeft - walk);
    });
});
 if (window.innerWidth < 768) { // Check if window width is less than 768px
      let myTimeout = setTimeout(function() {
        let facetsVerticalAside = document.querySelector('.facets-vertical aside');
        let isScrolling = false;

        window.addEventListener('scroll', () => {
          facetsVerticalAside.style.bottom = '-8px';

          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(() => {
            facetsVerticalAside.style.bottom = 'calc(20px + 72px)';
          }, 300);
        }, false);
      }, 500);
    }
document.querySelector(".procced__btn").addEventListener("click", function () {
     let quizType = this.getAttribute("quiz-type");
     //alert(quizType);
       window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({ 
          event: "quiz_proceed_btn",
          quiz_type: quizType 
      });
});


document.querySelector(".quiz-next-btn").addEventListener("click", function () {
    // Trigger GTM Event
  let currentvalue = this.getAttribute("current-select-value");
  let currentstep = this.getAttribute("current-step");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "quiz_selected_options",
        current_step: currentstep,
        current_select_value: currentvalue
    });

});
  
document.querySelector(".popup-close-btn").addEventListener("click", function () {
  let crossname = this.getAttribute("quiz-name");
  let crossstep = this.getAttribute("current-step");
   //alert(crossstep);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "quiz_close_button",
        quiz_name: crossname,
        quiz_step: crossstep
    });
});

document.addEventListener("click", function(event) {
    const button = event.target.closest(".quiz_add_to_cart");
    if (button) {
        let productId = button.getAttribute("data-product-id");
        let productTitle = button.getAttribute("data-product-title");
        let productPrice = button.getAttribute("data-product-price");
        var priceValue = parseFloat(productPrice) || 0;
        window.dataLayer = window.dataLayer || [];
       
           window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: "INR",
              value:productPrice,
              item_list_name: 'Quiz Products',
              items: [
                {
                item_id: productId,
                item_name: productTitle,
                price: productPrice,
                quantity: 1,
              },
              ],
            },
          });

       // alert(`ID: ${productId}\nTitle: ${productTitle}\nPrice: ₹${productPrice}`);
    }
});
